<div
  *ngIf="showBadge$ | async"
  matBadgeColor="warn"
  matTooltip="Pending Gaps"
  [matBadge]="candidateCount$ | async"
  [matBadgeSize]="size"
></div>
